import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import TopBar from '../../../components/TopBar';
import BusinessDetailsPageActionButtons from '../components/BusinessDetailsPageActionButtons';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import BusinessProfileForm from '../components/BusinessProfileForm';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';
import { useGetBusinessProfileHandler } from '../dataHandlers/getBusinessProfileHandler';

export default function BusinessProfileDetailsPage() {
  useDocumentTitle('Business Profile Details');
  const { profile_id } = useParams();
  const { businessProfile, isLoading } = useGetBusinessProfileHandler(profile_id);

  if (isLoading || !businessProfile) return <DocumentSkeletonForm />;

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      {businessProfile && (
        <Box sx={{ pb: 4 }}>
          <TopBar
            title={'Business Profile Details'}
            identifier={businessProfile?.profile_id}
            subTitle={businessProfile?.profile_id}
          >
            <BusinessDetailsPageActionButtons businessProfile={businessProfile} />
          </TopBar>
        </Box>
      )}

      <BusinessProfileForm
        onSubmit={() => {}}
        apiErrors={{}}
        initialData={businessProfile}
        readOnly={true}
        details={true}
        onCancel={() => {}}
      />
    </Stack>
  );
}
